export default __webpack_public_path__ + "static/media/A0006.0ce2c753.png";